module.exports = __webpack_public_path__ + "static/media/203.615a7ff6.png";